/**
 * @module constants
 */

export default {
  NORMAL: 'NORMAL',
  PUBLISH_ONLY: 'PUBLISH_ONLY'
};



// WEBPACK FOOTER //
// ./app/constants/clipperMode.js